import React from 'react';
import './App.css';
import Todolist from './components/todolistt/Todolist';



function App() {
  return (
    <>
      <Todolist/>
     
    </>
  );
}

export default App;
